import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// shadcn/ui class combiner — merges conditional classes and de-dupes Tailwind utilities.
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
